if ($('#timer-lockouts-datatable').length > 0) {
    url = $('#timer-lockouts-datatable').attr('data-url');
    dt = $("#timer-lockouts-datatable").DataTable({
        searchDelay: 500,
        order: [[2, 'desc']],
        language: window.datatableLanguage,
        searching: true,
        serverSide: true,
        processing: true,
        responsive: true,
        ajax: url,
        select: {
            style: 'os',
            selector: 'td:first-child',
            className: 'row-selected'
        },
        columns: [
            {
                data: 'user.first_name',
                name: 'user.first_name',
                orderable: true,
                searchable: true
            },
            {
                data: 'service.label',
                name: 'service.label',
                orderable: true,
                searchable: true
            },
            {
                data: 'created_at',
                name: 'created_at',
                orderable: true,
                searchable: true
            },
            {
                data: 'ended_at',
                name: 'ended_at',
                orderable: true,
                searchable: true
            },
            {
                data: 'actions',
                orderable: false,
                searchable: false
            },
            {
                data: 'user.last_name',
                name: 'user.last_name',
                searchable: true,
                visible: false
            },
            {
                data: 'user.email',
                name: 'user.email',
                searchable: true,
                visible: false
            },
        ],
        columnDefs: [
            {
                targets: 0,
                orderable: true
            },
            {
                targets: 1,
                orderable: true
            },
            {
                targets: 2,
                orderable: true
            },
            {
                targets: 3,
                orderable: false
            },
        ]
    });

    dt.on('draw', function () {
        refreshFsLightbox();
    });

    const filterSearch = document.querySelector('[data-kt-table-filter-timer-lockouts-datatable="search"]');
    filterSearch.addEventListener('keyup', function (e) {
        dt.search(e.target.value).draw();
    });
}
